<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" :model="formInline" label-width="80px" class="demo-form-inline">
      <el-form-item label="域名">
        <el-input v-model="formInline.domain" style="width:200px" placeholder="域名" />
      </el-form-item>
      <el-form-item label="授权类型">
        <el-select v-model="formInline.domain_type" placeholder="授权类型">
          <el-option
            v-for="item in options"
            :key="item.type"
            :label="item.name"
            :value="item.type"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { domainconfigurelist, domainconfigureupdate, authorizationtypelist } from '@/api/sourceMaterial.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      options: [],
      formInline: {
        domain: '',
        domain_type: null
      },
      type: null,
      id: null,
      status: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(type, item) {
      this.type = type
      this.options = item.domain_list
      // eslint-disable-next-line eqeqeq
      if (type == 1) {
        console.log('新增')
      }
      // eslint-disable-next-line eqeqeq
      if (type == 2) {
        console.log('编辑', item.item)
        this.formInline.domain = item.item.domain
        this.formInline.domain_type = item.item.domain_type
        this.id = item.item.id
        this.status = item.item.status
      }
    },
    async onSubmit() {
      // eslint-disable-next-line eqeqeq
      if (this.formInline.domain == '') {
        this.$message.error('请填写域名')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.formInline.domain_type == null) {
        this.$message.error('请选择授权类型')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.type == 1) {
        console.log('新增')
        const data = await domainconfigurelist(this.formInline)
        this.$message({
          message: '新增成功',
          type: 'success'
        })
        this.$emit('updatawe')
        console.log('data', data)
      } else {
        console.log('编辑')
        const data = await domainconfigureupdate({
          ...this.formInline,
          id: this.id,
          status: this.status
        })
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.$emit('updatawe')
        console.log('data', data)
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
